import React from 'react';
import { styled } from '@mui/material/styles';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { Routes } from './Routes';
import { useNavigationStore } from '@src/adapters/stores/useNavigationStore';

const PREFIX = 'breadcrumbs';

const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.text.primary,
  [`&.${PREFIX}-link`]: {
    fontWeight: 'bold',
  },
}));

const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  const { navigatedUser } = useNavigationStore();
  const decodeBreadcrumbValue = (encodedValue: string) => {
    try {
      const [displayValue] = decodeURIComponent(encodedValue).split('|');
      const match = matchPath(
        {
          path: Routes.OrganisationHospitalUser,
          end: false,
          caseSensitive: true,
        },
        location.pathname
      );
      if (match?.params.userSlug && match.params.userSlug === displayValue) {
        return navigatedUser?.name ?? displayValue;
      }
      return displayValue;
    } catch {
      return encodedValue;
    }
  };

  return (
    <Box component="nav" sx={{ width: '100%' }}>
      <Box
        component="ul"
        sx={{
          listStyle: 'none',
          display: 'flex',
          alignItems: 'center',
        }}>
        <li key="home">
          <StyledLink to="/" className={`${PREFIX}-link`}>
            System
          </StyledLink>
        </li>

        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          const breadcrumbValue = decodeBreadcrumbValue(value);

          if (value === 'home') {
            return null;
          }

          return (
            <React.Fragment key={index}>
              <Box
                component="li"
                sx={(theme) => ({
                  margin: '0 0.5rem',
                  color: theme.palette.text.primary,
                })}
                key={`spacer-${index}`}>
                /
              </Box>
              <li key={`item-${index}`}>
                <StyledLink to={to} className={`${PREFIX}-link`}>
                  {breadcrumbValue.replace(/([a-z])([A-Z])/g, '$1 $2')}
                </StyledLink>
              </li>
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
};

export default Breadcrumbs;
